export enum MESSAGE_ENUMS {
    
    INSUFFICIENT_BALANCE = "Insufficient funds for buying snowboards.",
    PAYMENT_SUCCESS = "Transaction Confirmed.",
    TRANSACTION_FAIL = "Transaction Failed.",
    SUCCESSFULLY_SUBMITTED = "Form Submitted Successfully."
    

    
}   